#include "_prelude_fog.fragment.glsl"
#include "_prelude_shadow.fragment.glsl"
#include "_prelude_lighting.glsl"

uniform sampler2D u_image0;
#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS
uniform sampler2D u_image1;
uniform float u_emissive_texture_available;
#endif
in vec2 v_pos0;

#ifdef FOG
in float v_fog_opacity;
#endif

#ifdef RENDER_SHADOWS
in vec4 v_pos_light_view_0;
in vec4 v_pos_light_view_1;
#endif

uniform vec3 u_ground_shadow_factor;

void main() {
    vec4 image_color = texture(u_image0, v_pos0);
    vec4 color;

#ifdef LIGHTING_3D_MODE
    const vec3 normal = vec3(0.0, 0.0, 1.0);

#ifdef RENDER_SHADOWS
    float cutoffOpacity = 1.0;
#ifdef RENDER_CUTOFF
    cutoffOpacity = cutoff_opacity(u_cutoff_params, 1.0 / gl_FragCoord.w);
#endif // RENDER_CUTOFF
#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS
    // Drape texture also contains the flood light color already
    // For this reason we decouple the emissive and flood lights areas
    // from the areas that should be lit with lights.
    // In the end we add the results instead of mixing them.
    vec3 unlit_base;
    vec3 emissive_base;
#ifdef USE_MRT1_RGBA
    // u_image1 stores the emissive-only premultiplied color contribution (exact, not a
    // scalar estimate), so the unlit portion is recovered by direct subtraction.
    // Uniform branch so the sample is skipped when no emissive attachment is bound.
    vec4 emissive_premult = vec4(0.0);
    if (u_emissive_texture_available > 0.5) {
        emissive_premult = texture(u_image1, v_pos0);
    }
    unlit_base = image_color.rgb - emissive_premult.rgb;
    emissive_base = emissive_premult.rgb;
#else
    float emissive_strength = image_color.a;
    if (u_emissive_texture_available > 0.5) {
        emissive_strength = texture(u_image1, v_pos0).r;
    }
    unlit_base = image_color.rgb * (1.0 - emissive_strength);
    emissive_base = image_color.rgb * emissive_strength;
#endif // !USE_MRT1_RGBA
    float ndotl = u_shadow_direction.z;
    float occlusion = 1.0;
    if (ndotl >= 0.0) {
        occlusion = shadow_occlusion(v_pos_light_view_0, v_pos_light_view_1, 1.0 / gl_FragCoord.w, 0.0);
    }
    ndotl = max(0.0, ndotl);
    // "lit" uses pretty much "shadowed_light_factor_normal_unbiased" as the directional component.
    vec3 lit = apply_lighting(unlit_base, normal, mix(1.0, (1.0 - (u_shadow_intensity * occlusion)) * ndotl, cutoffOpacity));
    vec3 emissive = compute_emissive_draped(emissive_base, 1.0 - u_shadow_intensity, occlusion, u_ground_shadow_factor);
    color.rgb = lit + emissive;
    color.a = 1.0;
#else // LIGHTING_3D_ALPHA_EMISSIVENESS
    float lighting_factor = shadowed_light_factor_normal_unbiased(normal, v_pos_light_view_0, v_pos_light_view_1, 1.0 / gl_FragCoord.w);
    color = apply_lighting(image_color, normal, mix(1.0, lighting_factor, cutoffOpacity));
#endif // !LIGHTING_3D_ALPHA_EMISSIVENESS
#else // RENDER_SHADOWS
    float lighting_factor = u_lighting_directional_dir.z;
#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS
#ifdef USE_MRT1_RGBA
    // See comment above on why u_image1 holds an exact premultiplied contribution.
    vec4 emissive_premult = vec4(0.0);
    if (u_emissive_texture_available > 0.5) {
        emissive_premult = texture(u_image1, v_pos0);
    }
    vec3 unlit_base = image_color.rgb - emissive_premult.rgb;
    color.rgb = apply_lighting(unlit_base, normal, lighting_factor) + emissive_premult.rgb;
    color.a = 1.0;
#else
    color = apply_lighting(image_color, normal, lighting_factor);
    float emissive_strength = image_color.a;
    if (u_emissive_texture_available > 0.5) {
        emissive_strength = texture(u_image1, v_pos0).r;
    }
    color.rgb = mix(color.rgb, image_color.rgb, emissive_strength);
    color.a = 1.0;
#endif // USE_MRT1_RGBA
#else // !LIGHTING_3D_ALPHA_EMISSIVENESS
    color = apply_lighting(image_color, normal, lighting_factor);
#endif // LIGHTING_3D_ALPHA_EMISSIVENESS
#endif // !RENDER_SHADOWS

#else // LIGHTING_3D_MODE
    color = image_color;
#endif // !LIGHTING_3D_MODE

#ifdef FOG
#ifdef ZERO_EXAGGERATION
    color = fog_dither(fog_apply_premultiplied(color, v_fog_pos));
#else
    color = fog_dither(fog_apply_from_vert(color, v_fog_opacity));
#endif
#endif
    glFragColor = color;
#ifdef OVERDRAW_INSPECTOR
    glFragColor = vec4(1.0);
#endif

    HANDLE_WIREFRAME_DEBUG;
}
